import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=10750356&scoped=true"
import script from "./ServiceConfig.vue?vue&type=script&lang=js"
export * from "./ServiceConfig.vue?vue&type=script&lang=js"
import style0 from "./ServiceConfig.vue?vue&type=style&index=0&id=10750356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10750356",
  null
  
)

export default component.exports